<template>
	<div>
		<h4 class="b-modal__title" v-html="loc.SOA_ORDER_MODAL_PREORDER_TITLE"></h4>
		<div class="b-modal__subtitle" v-html="subtitle"></div>
		<div class="b-product__list b-modal__list">
			<citrus-basket-items class='b-order__basketList' :view-mode="true" :items="params.productList"></citrus-basket-items>
		</div>
	</div>
</template>

<script>
import {Vue} from "ui.vue";

export default {
	name: "PopupBullets",
	props: {
		params: {
			type: [Boolean, Array, Object],
			default: () => {
				return {
					productList: false,
					deliveryDays: false
				}
			}
		},
	},
	computed: {
		loc() {
			return Vue.getFilteredPhrases("SOA_ORDER_MODAL_PREORDER_");
		},
		subtitle()
		{
			return this.loc.SOA_ORDER_MODAL_PREORDER_SUBTITLE.replaceAll('#DATE#',this.params.deliveryDays);
		}
	}
}
</script>

<style scoped>

</style>